const colors = {
  white: "var(--white)",
  black: "var(--black)",
  backgroundBlack: "var(--background-dark-900)",
  cardBackground: "#0D0C2A",
  cardBackgroundDarkBlue: "#0F0F37",
  lightGray: "#25253B",
  lightGrayPaperBackground: "rgba(216, 223, 236, 0.3)",
  lightGrayText: "#b9b9b9",
  lightGray_GoBackButton: "#272740",
  lightGrayHover: "#31314D",
  redPink: "var(--brand-pink)",
  purple: "var(--additional-dark-theme-purple)",
  textDark: "var(--text-light-theme-primary)",
  buttonBackgroundSelected: "#1D1D31",
  selectGreyBorder: "rgb(45, 45, 66)",
  selectedCollectionItem: "rgb(255, 83, 109, 0.4)",
  shadowGradient: "linear-gradient(0deg, rgba(0,0,0,1) 28%, rgba(0,0,0,0) 100%)",
  shadowGradientBothEnds: "linear-gradient(0deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.2) 33%, rgba(0,0,0,0.2) 68%, rgba(0,0,0,0.5) 100%)",
  shadowRadialGradient: "radial-gradient(rgba(0,0,0,0.25) 0%, rgba(0,0,0,0) 60%)",
  nicheBackgroundShadow: "linear-gradient(0deg,rgba(11, 11, 40, 1) 0%, rgba(11, 11, 40, 0.7) 90%, rgba(0,0,0,0.5) 100%)",
  greenGradient: "linear-gradient(180deg, #32B97E 0%, #26EA94 100%)",
  purpleGradient: "var(--accent-gradient)",

  RedditGradient: "linear-gradient(135deg, #FDDD8F 0%, #DF3200 100%)",
  TwitterGradient: "linear-gradient(135deg, #71D6FC 0%, #00ACED 100%)",
  DiscordGradient: "linear-gradient(135deg, #828CFA 0%, #5865F2 100%)",
};

export const sizes = {
  containerSize: "690px",
  containerWideSize: "1070px",
};

export default colors;
